import React, { useState, useEffect } from 'react';
import {
  Input,
  InputGroup,
  Button,
  Stack,
  Breadcrumb,
  Divider,
  Container,
  CheckPicker,
  Panel,
  Col,
  IconButton,
  Loader,
  Drawer,
  Modal,
  Grid,
  Row,
  Message,
  toaster,
  Pagination,
  Table,
  Tooltip,
  Whisper
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import useLabel from '@/clientWeb/hook/Label';
import axios from 'axios';
import CopyToClipboard from 'react-copy-to-clipboard';
import ReloadIcon from '@rsuite/icons/Reload';

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const { HeaderCell, Cell } = Table;
const BulkCosting = () => {
  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [data123, setData123] = useState([]);
  const [meta123, setMeta123] = useState<MetaData>();
  const [bulkCostingData, setBulkCostingData] = useState([]);

  useEffect(() => {
    fetchbulkdata();
  }, []);
  const fetchbulkdata = async () => {
    try {
      const response = await fetch(`${globalIP}/api/bulks-costings?populate=*&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/bulks-costings?populate=*&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        allData.push(...pageJson.data);
      }
      setBulkCostingData(allData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const enrichedProductData = data123.map(product => {
    const bulkCosting = bulkCostingData.find(
      costing => costing.attributes.ProductCode === product.attributes.ProductCode
    );

    return {
      ...product,
      ProductName: bulkCosting ? bulkCosting.attributes.ProductName : null,
      ProductCode: bulkCosting ? bulkCosting.attributes.ProductCode : null,
      ProductId: bulkCosting ? bulkCosting.attributes.ProductId : null,
      Description: bulkCosting ? bulkCosting.attributes.Description : null,
      createdAt: bulkCosting ? bulkCosting.attributes.createdAt : null,
      updatedAt: bulkCosting ? bulkCosting.attributes.updatedAt : null,
      publishedAt: bulkCosting ? bulkCosting.attributes.publishedAt : null,
      MaterialName: bulkCosting ? bulkCosting.attributes.MaterialName : null,
      AlluminiumWt: bulkCosting ? bulkCosting.attributes.AlluminiumWt : null,
      ThermaPBL: bulkCosting ? bulkCosting.attributes.ThermaPBL : null,
      ThermaPBW: bulkCosting ? bulkCosting.attributes.ThermaPBW : null,
      ThermaPBH: bulkCosting ? bulkCosting.attributes.ThermaPBH : null,
      BaseCostTherma: bulkCosting ? bulkCosting.attributes.BaseCostTherma : null,
      TPPL: bulkCosting ? bulkCosting.attributes.TPPL : null,
      TPPW: bulkCosting ? bulkCosting.attributes.TPPW : null,
      TPPH: bulkCosting ? bulkCosting.attributes.TPPH : null,
      BaseCostPacking: bulkCosting ? bulkCosting.attributes.BaseCostPacking : null,
      ThermaCost: bulkCosting ? bulkCosting.attributes.ThermaCost : null,
      Part1L: bulkCosting ? bulkCosting.attributes.Part1L : null,
      Part1W: bulkCosting ? bulkCosting.attributes.Part1W : null,
      Part1H: bulkCosting ? bulkCosting.attributes.Part1H : null,
      Part2L: bulkCosting ? bulkCosting.attributes.Part2L : null,
      Part2W: bulkCosting ? bulkCosting.attributes.Part2W : null,
      Part2H: bulkCosting ? bulkCosting.attributes.Part2H : null,
      Part3L: bulkCosting ? bulkCosting.attributes.Part3L : null,
      Part3W: bulkCosting ? bulkCosting.attributes.Part3W : null,
      Part3H: bulkCosting ? bulkCosting.attributes.Part3H : null,
      WoodCost: bulkCosting ? bulkCosting.attributes.WoodCost : null,
      WBanai: bulkCosting ? bulkCosting.attributes.WBanai : null,
      WTCost: bulkCosting ? bulkCosting.attributes.WTCost : null,
      WtenperCharge: bulkCosting ? bulkCosting.attributes.WtenperCharge : null,
      Wfiveperwastage: bulkCosting ? bulkCosting.attributes.Wfiveperwastage : null,
      WTCostWastage: bulkCosting ? bulkCosting.attributes.WTCostWastage : null,
      MetalWt: bulkCosting ? bulkCosting.attributes.MetalWt : null,
      Bata_Metal: bulkCosting ? bulkCosting.attributes.Bata_Metal : null,
      MetalCost: bulkCosting ? bulkCosting.attributes.MetalCost : null,
      MetalWastfiveper: bulkCosting ? bulkCosting.attributes.MetalWastfiveper : null,
      MetalWatCost: bulkCosting ? bulkCosting.attributes.MetalWatCost : null,
      GlassWeight: bulkCosting ? bulkCosting.attributes.GlassWeight : null,
      GlassRate: bulkCosting ? bulkCosting.attributes.GlassRate : null,
      GlassTCost: bulkCosting ? bulkCosting.attributes.GlassTCost : null,
      GlassFreight: bulkCosting ? bulkCosting.attributes.GlassFreight : null,
      GlassTCRateFreight: bulkCosting ? bulkCosting.attributes.GlassTCRateFreight : null,
      GlassWasteFivePer: bulkCosting ? bulkCosting.attributes.GlassWasteFivePer : null,
      GlassTCWastage: bulkCosting ? bulkCosting.attributes.GlassTCWastage : null,
      GlassTCFlower: bulkCosting ? bulkCosting.attributes.GlassTCFlower : null,
      FinSize: bulkCosting ? bulkCosting.attributes.FinSize : null,
      FinRate: bulkCosting ? bulkCosting.attributes.FinRate : null,
      FinTotal: bulkCosting ? bulkCosting.attributes.FinTotal : null,
      FinEachprPrice: bulkCosting ? bulkCosting.attributes.FinEachprPrice : null,
      FinFivePerWaste: bulkCosting ? bulkCosting.attributes.FinFivePerWaste : null,
      FinNoOfBallUse: bulkCosting ? bulkCosting.attributes.FinNoOfBallUse : null,
      FinTotalCost: bulkCosting ? bulkCosting.attributes.FinTotalCost : null,
      FinTotall: bulkCosting ? bulkCosting.attributes.FinTotall : null,
      LabNoOfDay: bulkCosting ? bulkCosting.attributes.LabNoOfDay : null,
      LabCost: bulkCosting ? bulkCosting.attributes.LabCost : null,
      LabWasteFivePer: bulkCosting ? bulkCosting.attributes.LabWasteFivePer : null,
      CCML: bulkCosting ? bulkCosting.attributes.CCML : null,
      CCMW: bulkCosting ? bulkCosting.attributes.CCMW : null,
      CCMH: bulkCosting ? bulkCosting.attributes.CCMH : null,
      CCMC: bulkCosting ? bulkCosting.attributes.CCMC : null,
      MSI1I: bulkCosting ? bulkCosting.attributes.MSI1I : null,
      MSI1L: bulkCosting ? bulkCosting.attributes.MSI1L : null,
      MSI1W: bulkCosting ? bulkCosting.attributes.MSI1W : null,
      MSI1H: bulkCosting ? bulkCosting.attributes.MSI1H : null,
      MSI1C: bulkCosting ? bulkCosting.attributes.MSI1C : null,
      MSI2I: bulkCosting ? bulkCosting.attributes.MSI2I : null,
      MSI2L: bulkCosting ? bulkCosting.attributes.MSI2L : null,
      MSI2W: bulkCosting ? bulkCosting.attributes.MSI2W : null,
      MSI2H: bulkCosting ? bulkCosting.attributes.MSI2H : null,
      MSI2C: bulkCosting ? bulkCosting.attributes.MSI2C : null,
      MSINoCost: bulkCosting ? bulkCosting.attributes.MSINoCost : null,
      MSITCostInner: bulkCosting ? bulkCosting.attributes.MSITCostInner : null,
      MSINofPvc: bulkCosting ? bulkCosting.attributes.MSINofPvc : null,
      MSINofPvcBox: bulkCosting ? bulkCosting.attributes.MSINofPvcBox : null,
      MSINofPvcBoxInner: bulkCosting ? bulkCosting.attributes.MSINofPvcBoxInner : null,
      MSITCostInnerr: bulkCosting ? bulkCosting.attributes.MSITCostInnerr : null,
      CCPNoFPiece: bulkCosting ? bulkCosting.attributes.CCPNoFPiece : null,
      CCPCost: bulkCosting ? bulkCosting.attributes.CCPCost : null,
      CCPCBM: bulkCosting ? bulkCosting.attributes.CCPCBM : null,
      FeltSize: bulkCosting ? bulkCosting.attributes.FeltSize : null,
      FeltRate: bulkCosting ? bulkCosting.attributes.FeltRate : null,
      FeltCost: bulkCosting ? bulkCosting.attributes.FeltCost : null,
      PlateWeight: bulkCosting ? bulkCosting.attributes.PlateWeight : null,
      PlateRate: bulkCosting ? bulkCosting.attributes.PlateRate : null,
      PlateCost: bulkCosting ? bulkCosting.attributes.PlateCost : null,
      PPNSize: bulkCosting ? bulkCosting.attributes.PPNSize : null,
      PPNRate: bulkCosting ? bulkCosting.attributes.PPNRate : null,
      PPNCost: bulkCosting ? bulkCosting.attributes.PPNCost : null,
      PALength: bulkCosting ? bulkCosting.attributes.PALength : null,
      PARate: bulkCosting ? bulkCosting.attributes.PARate : null,
      PACost: bulkCosting ? bulkCosting.attributes.PACost : null,
      NikSize: bulkCosting ? bulkCosting.attributes.NikSize : null,
      NikRate: bulkCosting ? bulkCosting.attributes.NikRate : null,
      NikCost: bulkCosting ? bulkCosting.attributes.NikCost : null,
      CBNSize: bulkCosting ? bulkCosting.attributes.CBNSize : null,
      CBNRate: bulkCosting ? bulkCosting.attributes.CBNRate : null,
      CBNCost: bulkCosting ? bulkCosting.attributes.CBNCost : null,
      Bubble: bulkCosting ? bulkCosting.attributes.Bubble : null,
      LabForSheet: bulkCosting ? bulkCosting.attributes.LabForSheet : null,
      TransCBM: bulkCosting ? bulkCosting.attributes.TransCBM : null,
      TransPPCBM: bulkCosting ? bulkCosting.attributes.TransPPCBM : null,
      TransCost: bulkCosting ? bulkCosting.attributes.TransCost : null,
      TransCost_Overhead: bulkCosting ? bulkCosting.attributes.TransCost_Overhead : null,
      TotalwithMargin: bulkCosting ? bulkCosting.attributes.TotalwithMargin : null,
      TotalPriceUSD: bulkCosting ? bulkCosting.attributes.TotalPriceUSD : null,
      TotalPriceUSD1: bulkCosting ? bulkCosting.attributes.TotalPriceUSD1 : null,
    };
  });
  useEffect(() => {
    console.log('meta123', meta123);
    console.log('data123', data123);
    console.log('enrichedProductData', enrichedProductData);
  }, [data123, enrichedProductData]);
  const defaultColumns = [
    {
      key: 'SerialNumber',
      label: 'Serial Number',
      fixed: true,
      width: 80,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>SrNo.</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell>{(rowData, rowIndex) => rowIndex + 1}</Table.Cell> // Add serial number based on row index
    }, {
      key: 'Image',
      label: 'Image',
      fixed: true,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Image</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell>
          {rowData => {
            // Define a function to show the enlarged image on hover
            const renderTooltip = imageSrc => (
              <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                <img
                  src={imageSrc}
                  alt="Product Image"
                  style={{ width: 400, height: 400, objectFit: 'contain' }}
                />
              </Tooltip>
            );

            return (
              <Whisper
                trigger="hover"
                placement="right"
                speaker={renderTooltip(
                  `${ip}${rowData.attributes?.CoverImage?.data?.attributes?.url}`
                )}
              >
                <img
                  src={`${ip}${rowData.attributes?.CoverImage?.data?.attributes?.url}`}
                  alt="Product Image"
                  style={{ width: 50, height: 50, marginTop: '-16px', objectFit: 'contain' }}
                />
              </Whisper>
            );
          }}
        </Table.Cell>
      )
    },

    {
      key: 'ProductId',
      label: `${label[0]?.attributes.AliasCode}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.AliasCode}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell>{rowData => rowData.attributes.ProductId}</Table.Cell>
    },

    {
      key: 'Description',
      label: `${label[0]?.attributes.Description}`,
      width: 300,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.Description}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell>{rowData => rowData.attributes.Description}</Table.Cell>
    },
    {
      key: 'ProductName',
      label: `${label[0]?.attributes.ProductName}`,
      width: 250,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.ProductName}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell>{rowData => rowData.attributes.ProductName}</Table.Cell>
    },

    {
      key: 'FinishName',
      label: `${label[0]?.attributes.finish}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.finish}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell>{rowData => rowData.attributes.FinishName}</Table.Cell>
    },
    {
      key: 'ColorName',
      label: `${label[0]?.attributes.color}`,
      width: 150,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.color}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell>{rowData => rowData.attributes.ColorName}</Table.Cell>
    },
    {
      key: 'AlluminiumWt',
      label: 'Alluminium Weight',
      width: 150,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Alluminium Weight</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell>{rowData => rowData.AlluminiumWt ?? 'N/A'}</Table.Cell> // Display the weight
    },
    {
      key: 'TotalPriceUSD',
      label: 'TotalPriceUSD',
      width: 150,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Total Price USD</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell>{rowData => rowData.TotalPriceUSD ?? 'N/A'}</Table.Cell> // Display the weight
    }
  ];
  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
  const [compact, setCompact] = useState(true);
  const CustomCell = compact ? CompactCell : Cell;
  const CustomHeaderCell = compact ? CompactHeaderCell : HeaderCell;
  const [columnKeys, setColumnKeys] = React.useState(
    defaultColumns
      .map(column => column.key)
      .filter(
        key =>
          key !== 'ProductCost' &&
          key !== 'ProductCode' &&
          key !== 'Category' &&
          key !== 'ProductType' &&
          key !== 'NetWeight' &&
          key !== 'GrossWeight' &&
          key !== 'HSNCode' &&
          key !== 'MOQ' &&
          key !== 'BuyerName' &&
          key !== 'BuyerSku'
      )
  );
  const [selectedImagePath, setSelectedImagePath] = useState('');
  const { attributesName } = useLabel();
  const [sizeshow, setSizeShow] = useState(false);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const [showDrawer, setShowDrawer] = useState(false);
  const [openSet, setOpenSet] = useState(false);
  const [head, setHead] = useState([]);
  useEffect(() => {
    fetchDataHeads();
  }, []);
  const fetchDataHeads = async () => {
    try {
      const response = await fetch(`${globalIP}/api/mstfilters?populate=*`);
      const json = await response.json();
      const filteredData = json.data.map(item => ({
        FilterName: item.attributes.FilterName,
        filterstatus: item.attributes.filterstatus
      }));
      setHead(filteredData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const [selectedCategory, setSelectedCategory] = useState([]);
  const [excelProductType, setexcelProductType] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState([]);
  const [selectedhsn, setSelectedhsn] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState([]);
  const [selectedSearch, setSelectedSearch] = useState([]);
  const [selectedAlias, setSelectedAlias] = useState([]);
  const [selectedpron, setSelectedPron] = useState([]);
  const [selectedpd, setSelectedProd] = useState([]);
  const [selectedmade, setSelectedMade] = useState([]);
  const [selectedsku, setSelectedSku] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [progress, setProgress] = useState(0);
  const [reload, setReload] = useState(false);
  const [page, setPage] = useState(1);
  const [noData, setNoData] = useState(false);
  const handleChangeLimit = () => {
    setPage(1);
  };
  const TableFetchData = async () => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);

    let categoryFilter = '';
    if (selectedCategory.length > 0) {
      const categoryFilterString = selectedCategory
        .map(cat => `filters[CategoryCode][$eq]=${cat}`)
        .join('&');
      categoryFilter = `&${categoryFilterString}`;
    }
    let protypeFilter = '';
    if (excelProductType.length > 0) {
      const protypeFilterString = excelProductType
        .map(pro => `filters[ProductTypeCode][$eq]=${pro}`)
        .join('&');
      protypeFilter = `&${protypeFilterString}`;
    }
    let colorFilter = '';
    if (selectedColor.length > 0) {
      const colorFilterString = selectedColor
        .map(color => `filters[ColorCode][$eq]=${color}`)
        .join('&');
      colorFilter = `&${colorFilterString}`;
    }
    let finishFilter = '';
    if (selectedFinish.length > 0) {
      const finishFilterString = selectedFinish
        .map(finish => `filters[FinishCode][$eq]=${finish}`)
        .join('&');
      finishFilter = `&${finishFilterString}`;
    }
    let hsnFilter = '';
    if (selectedhsn.length > 0) {
      const hsnFilterString = selectedhsn.map(hsn => `filters[HSNCode][$eq]=${hsn}`).join('&');
      hsnFilter = `&${hsnFilterString}`;
    }
    let matFilter = '';
    // if (selectedmaterial.length > 0) {
    //   const matFilterString = selectedmaterial
    //     .map(mat => `filters[ProductionDetail[0].MaterialCode][$eq]=${mat}`)
    //     .join('&');
    //   matFilter = `&${matFilterString}`;
    // }
    let buyerFilter = '';
    if (selectedBuyer.length > 0) {
      const buyerFilterString = selectedBuyer
        .map(buyer => `filters[BuyerName][$eq]=${buyer}`)
        .join('&');
      buyerFilter = `&${buyerFilterString}`;
    }
    let searchFilter = '';
    if (selectedSearch.length > 0) {
      const SearchFilterString = selectedSearch
        .map(search => `filters[SearchKeyword][$eq]=${search}`)
        .join('&');
      searchFilter = `&${SearchFilterString}`;
    }
    let aliasFilter = '';
    if (selectedAlias.length > 0) {
      const aliasFilterString = selectedAlias
        .map(alias => `filters[ProductId][$eq]=${alias}`)
        .join('&');
      aliasFilter = `&${aliasFilterString}`;
    }
    let pronFilter = '';
    if (selectedpron.length > 0) {
      const pronFilterString = selectedpron
        .map(pron => `filters[ProductName][$eq]=${pron}`)
        .join('&');
      pronFilter = `&${pronFilterString}`;
    }
    let prodFilter = '';
    if (selectedpd.length > 0) {
      const prodFilterString = selectedpd
        .map(prod => `filters[ProductDesigner][$eq]=${prod}`)
        .join('&');
      prodFilter = `&${prodFilterString}`;
    }
    let madeFilter = '';
    if (selectedmade.length > 0) {
      const madeFilterString = selectedmade.map(made => `filters[MadeBy][$eq]=${made}`).join('&');
      madeFilter = `&${madeFilterString}`;
    }
    let skuFilter = '';
    if (selectedsku.length > 0) {
      const skuFilterString = selectedsku.map(sku => `filters[BuyerSku][$eq]=${sku}`).join('&');
      skuFilter = `&${skuFilterString}`;
    }
    let searchQryFilter = '';
    if (searchQuery.length > 0) {
      let searchQryy = searchQuery.trim();
      const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}`;
      searchQryFilter = `&${searchQry}`;
    }
    const response = await fetch(
      `${globalIP}/api/products?populate=*&sort[0]=id:desc&pagination[page]=${page}${searchQryFilter}${categoryFilter}${protypeFilter}${colorFilter}${finishFilter}${hsnFilter}${matFilter}${buyerFilter}${searchFilter}${aliasFilter}${pronFilter}${prodFilter}${madeFilter}${skuFilter}`
    );

    const json = await response.json();
    setData123(json.data);
    setMeta123(json.meta);
    setIsLoading(false);
  };

  useEffect(() => {
    TableFetchData();
  }, [page, reload]);
  useEffect(() => {
    TableFetchData();
  }, []);

  const ip = globalIP;

  const [selectedCategoryCode, setSelectedCategoryCode] = useState([]);
  const [categorydata, setCategorydata] = useState([]);
  const [isLoadingc, setIsLoadingc] = useState(false);
  useEffect(() => {
    fetchDatac();
  }, []);
  const fetchDatac = async () => {
    setProgress(30);
    if (isLoadingc) {
      return;
    }
    setIsLoadingc(true);
    try {
      const response = await fetch(
        `${ip}/api/mstcategories?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      setProgress(60);
      const json = await response.json();
      const allData = [];

      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstcategories?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.CategoryName,
          value: item.attributes.CategoryCode
        }));
        allData.push(...processedData);
      }
      setCategorydata(allData);
      setIsLoadingc(false);
      setProgress(100);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [productypedata, setProductypedata] = useState([]);
  const [isLoadingpro, setIsLoadingpro] = useState(false);
  useEffect(() => {
    if (selectedCategoryCode) {
      fetchData2();
    }
  }, [selectedCategoryCode]);
  const fetchData2 = async () => {
    if (isLoadingpro) {
      return;
    }
    setIsLoadingpro(true);
    try {
      const productIdsQueryParam = selectedCategoryCode
        .map(id => `filters[Categorycode][$in][]=${id}`)
        .join('&');
      const apiUrl = `${globalIP}/api/mstproducttypes?${productIdsQueryParam}&populate=*&pagination[page]=1`;

      const response = await fetch(apiUrl);
      const json = await response.json();

      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstproducttypes?${productIdsQueryParam}&populate=*&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.ProductTypeName,
          value: item.attributes.ProductTypeCode
        }));
        allData.push(...processedData);
      }
      setProductypedata(allData);
      setIsLoadingpro(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [finishdata, setFinishdata] = React.useState([]);
  const [isLoadingfin, setIsLoadingfin] = React.useState(false);
  useEffect(() => {
    fetchData4();
  }, []);
  const fetchData4 = async () => {
    if (isLoadingfin) {
      return;
    }
    setIsLoadingfin(true);
    try {
      const response = await fetch(
        `${ip}/api/mstfinishes?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstfinishes?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.FinishName,
          value: item.attributes.FinishCode
        }));
        allData.push(...processedData);
      }
      setFinishdata(allData);
      setIsLoadingfin(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [hsndata, setHsndata] = React.useState([]);
  const [isLoadinghsn, setIsLoadinghsn] = React.useState(false);
  useEffect(() => {
    fetchData6();
  }, []);
  const fetchData6 = async () => {
    if (isLoadinghsn) {
      return;
    }
    setIsLoadinghsn(true);
    try {
      const response = await fetch(
        `${ip}/api/msthscodes?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/msthscodes?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.hscode,
          value: item.attributes.hscode
        }));
        allData.push(...processedData);
      }
      setHsndata(allData);
      setIsLoadinghsn(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [colordata, setColordata] = useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = useState(false);
  useEffect(() => {
    fetchData5();
  }, []);
  const fetchData5 = async () => {
    if (isLoadingcolor) {
      return;
    }
    setIsLoadingcolor(true);
    try {
      const response = await fetch(
        `${ip}/api/mstcolors?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstcolors?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.ColorName,
          value: item.attributes.ColorCode
        }));
        allData.push(...processedData);
      }
      setColordata(allData);
      setIsLoadingcolor(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [buyernamedata, setBuyerNamedata] = useState([]);
  const [isLoadingbu, setIsLoadingbu] = useState(false);
  useEffect(() => {
    fetchDatabuyerN();
  }, []);
  const fetchDatabuyerN = async () => {
    if (isLoadingbu) {
      return;
    }
    setIsLoadingbu(true);
    try {
      const response = await fetch(`${ip}/api/buyer-details?&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${ip}/api/buyer-details?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.buyernm,
          value: item.attributes.buyernm
        }));
        allData.push(...processedData);
      }
      setBuyerNamedata(allData);
      setIsLoadingbu(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [searchdata, setSearchdata] = useState([]);
  const [isLoadingse, setIsLoadingse] = useState(false);
  useEffect(() => {
    fetchDataSearch();
  }, []);
  const fetchDataSearch = async () => {
    if (isLoadingse) {
      return;
    }
    setIsLoadingse(true);
    try {
      const response = await fetch(`${ip}/api/searchs-keyword`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords

      json.forEach(item => {
        if (item.SearchKeyword && !uniqueKeywords.has(item.SearchKeyword)) {
          uniqueKeywords.add(item.SearchKeyword);
        }
      });

      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setSearchdata(processedData);
      setIsLoadingse(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [proNamedata, setProdNamedata] = useState([]);
  const [isLoadingpron, setIsLoadingpron] = useState(false);
  useEffect(() => {
    fetchDatapron();
  }, []);
  const fetchDatapron = async () => {
    if (isLoadingpron) {
      return;
    }
    setIsLoadingpron(true);
    try {
      const response = await fetch(`${ip}/api/products-name`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords

      json.forEach(item => {
        if (item.ProductName && !uniqueKeywords.has(item.ProductName)) {
          uniqueKeywords.add(item.ProductName);
        }
      });

      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setProdNamedata(processedData);
      setIsLoadingpron(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [proDdata, setProdDdata] = useState([]);
  const [isLoadingprod, setIsLoadingprod] = useState(false);
  useEffect(() => {
    fetchDataprod();
  }, []);
  const fetchDataprod = async () => {
    if (isLoadingprod) {
      return;
    }
    setIsLoadingprod(true);
    try {
      const response = await fetch(`${ip}/api/products-designer`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
      json.forEach(item => {
        if (item.ProductDesigner && !uniqueKeywords.has(item.ProductDesigner)) {
          uniqueKeywords.add(item.ProductDesigner);
        }
      });
      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setProdDdata(processedData);
      setIsLoadingprod(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [madedata, setMadedata] = useState([]);
  const [isLoadingmade, setIsLoadingmade] = useState(false);
  useEffect(() => {
    fetchDatamade();
  }, []);
  const fetchDatamade = async () => {
    if (isLoadingmade) {
      return;
    }
    setIsLoadingmade(true);
    try {
      const response = await fetch(`${ip}/api/mades-by`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
      json.forEach(item => {
        if (item.MadeBy && !uniqueKeywords.has(item.MadeBy)) {
          uniqueKeywords.add(item.MadeBy);
        }
      });
      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setMadedata(processedData);
      setIsLoadingmade(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [aliasdata, setAliasdata] = useState([]);
  const [isLoadingalias, setIsLoadinalias] = useState(false);
  useEffect(() => {
    fetchDataalias();
  }, []);
  const fetchDataalias = async () => {
    if (isLoadingalias) {
      return;
    }
    setIsLoadinalias(true);
    try {
      const response = await fetch(`${ip}/api/fetchs-aliascd`);
      const json = await response.json();
      const processedData = json.map(item => ({
        label: item.ProductId,
        value: item.ProductId
      }));
      setAliasdata(processedData);
      setIsLoadinalias(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [skudata, setSkudata] = useState([]);
  const [isLoadingsku, setIsLoadinsku] = useState(false);
  useEffect(() => {
    fetchDatasku();
  }, []);
  const fetchDatasku = async () => {
    if (isLoadingsku) {
      return;
    }
    setIsLoadinsku(true);
    try {
      const response = await fetch(`${ip}/api/buyers-sku`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
      json.forEach(item => {
        if (item.BuyerSku && !uniqueKeywords.has(item.BuyerSku)) {
          uniqueKeywords.add(item.BuyerSku);
        }
      });
      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setSkudata(processedData);
      setIsLoadinsku(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  // Debounce effect for searchQuery
  useEffect(() => {
    // setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    // console.log('searchQuery', debouncedSearchQuery);
    setPage(1);
    TableFetchData(); // Your data fetching function
  }, [debouncedSearchQuery]);

  const handleSearch = value => {
    setSearchQuery(value);

  };

  const [selectedItems, setSelectedItems] = useState([]);

  const [filtersApplied, setFiltersApplied] = useState(false);
  const handleCheckAll = (value, checked) => {
    if (filtersApplied) {
      const filteredProducts = applyFilters();
      setSelectedItems(checked ? filteredProducts.map(item => item.id) : []);
    } else {
      setSelectedItems(checked ? data123.map(item => item.id) : []);
    }
  };

  const applyFilters = () => {
    let filteredProducts = data123;

    if (selectedCategory.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedCategory.includes(item.attributes.CategoryCode)
      );
    }

    if (excelProductType.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        excelProductType.includes(item.attributes.ProductTypeCode)
      );
    }

    if (selectedColor.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedColor.includes(item.attributes.ColorCode)
      );
    }

    if (selectedFinish.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedFinish.includes(item.attributes.FinishCode)
      );
    }

    if (selectedhsn.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedhsn.includes(item.attributes.HSNCode)
      );
    }
    return filteredProducts;
  };
  const handleCheckboxChange = (value, checked) => {
    if (checked) {
      setSelectedItems(prevSelectedItems => [...prevSelectedItems, value]);
    } else {
      setSelectedItems(prevSelectedItems => prevSelectedItems.filter(item => item !== value));
    }
  };
  const [open, setOpen] = useState(false);
  const [modeldata, setmodeldata] = useState([]);

  const handleOpen = (value, prdcd) => {
    setOpen(true);
    const newArray = [...data123];
    const filteredData = newArray.filter(item => item.attributes.ProductId === prdcd);
    setmodeldata(filteredData);
  };
  const handleClose = () => setOpen(false);


  const handleCategoryChange = value => {
    setSelectedCategory(value);
    setSelectedCategoryCode(value);
    setFiltersApplied(true);
    setPage(1);
    setReload(prev => !prev);
    if (searchQuery) {
      setSearchQuery('')
    }
  };

  const handleProductTypeChange = value => {
    setexcelProductType(value);
    setFiltersApplied(true);
    setPage(1);
    setReload(prev => !prev);
    if (searchQuery) {
      setSearchQuery('')
    }
  };

  const handleColorChange = value => {
    setSelectedColor(value);
    setFiltersApplied(true);
    setPage(1);
    setReload(prev => !prev);
    if (searchQuery) {
      setSearchQuery('')
    }
  };

  const handleFinishChange = value => {
    setSelectedFinish(value);
    setFiltersApplied(true);
    setPage(1);
    setReload(prev => !prev);
    if (searchQuery) {
      setSearchQuery('')
    }
  };

  const handleHSNChange = value => {
    setSelectedhsn(value);
    setFiltersApplied(true);
    setPage(1);
    setReload(prev => !prev);
    if (searchQuery) {
      setSearchQuery('')
    }
  };

  const handleAliasChange = value => {
    setSelectedAlias(value);
    setPage(1);
    setReload(prev => !prev);
    if (searchQuery) {
      setSearchQuery('')
    }
  };
  const handleBuyerChange = value => {
    setSelectedBuyer(value);
    setPage(1);
    setReload(prev => !prev);
    if (searchQuery) {
      setSearchQuery('')
    }
  };
  const handleSearchChange = value => {
    setSelectedSearch(value);
    setPage(1);
    setReload(prev => !prev);
    if (searchQuery) {
      setSearchQuery('')
    }
  };
  const handleProNameChange = value => {
    setSelectedPron(value);
    setPage(1);
    setReload(prev => !prev);
    if (searchQuery) {
      setSearchQuery('')
    }
  };
  const handleProDChange = value => {
    setSelectedProd(value);
    setPage(1);
    setReload(prev => !prev);
    if (searchQuery) {
      setSearchQuery('')
    }
  };
  const handleMadeChange = value => {
    setSelectedMade(value);
    setPage(1);
    setReload(prev => !prev);
    if (searchQuery) {
      setSearchQuery('')
    }
  };
  const handleSkuChange = value => {
    setSelectedSku(value);
    setPage(1);
    setReload(prev => !prev);
    if (searchQuery) {
      setSearchQuery('')
    }
  };
  const FixedLoader = () => (
    <Loader
      content="Loading..."
      style={{
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        bottom: '0',
        background: '#fff',
        width: '100%',
        padding: '4px 0'
      }}
    />
  );
  const renderMenu = menu => {
    return (
      <>
        {menu}
        {isLoadingse && <FixedLoader />}
      </>
    );
  };
  const renderMenu1 = menu => {
    return (
      <>
        {menu}
        {isLoadingalias && <FixedLoader />}
      </>
    );
  };
  const renderMenu2 = menu => {
    return (
      <>
        {menu}
        {isLoadingpron && <FixedLoader />}
      </>
    );
  };
  const renderMenu3 = menu => {
    return (
      <>
        {menu}
        {isLoadingprod && <FixedLoader />}
      </>
    );
  };
  const renderMenu4 = menu => {
    return (
      <>
        {menu}
        {isLoadingmade && <FixedLoader />}
      </>
    );
  };
  const renderMenu5 = menu => {
    return (
      <>
        {menu}
        {isLoadingsku && <FixedLoader />}
      </>
    );
  };

  const [excelData, setExcelData] = useState([]); // Stores the fetched Excel data
  const [apiData, setApiData] = useState([]); // Stores the fetched data from the API
  useEffect(() => {
    console.log('excelData', excelData);
  }, [excelData])
  const fetchAlldata = async () => {
    try {
      const response = await fetch(`${globalIP}/api/products?populate=*&sort[0]=id:desc&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${ip}/api/products?populate=*&sort[0]=id:desc&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        allData.push(...pageJson.data);
      }
      setApiData(allData.sort((a, b) => {
        // Sort by id in ascending order
        return b.id - a.id;  // Change to b.id - a.id for descending order
      }));
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const removeSheetBGColor = async () => {
    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycby_j8qhPK4Cth0zqINFZt3p2X1dx184WO2k_5Py-bET-bzVxjpe3wMdAdL0snRUK47Y/exec');
      const json = await response.json();
      if (json) {
        console.log('removed successfully')
      }

    } catch (error) {
      console.error('Error fetching Excel data:', error);
    }
  };
  const fetchExcelData = async () => {
    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycby_j8qhPK4Cth0zqINFZt3p2X1dx184WO2k_5Py-bET-bzVxjpe3wMdAdL0snRUK47Y/exec');
      const json = await response.json();
      setExcelData(json.data); // Set the fetched data from Excel
      // console.log('json.data');
      // console.log('json.data');
      // console.log(json.data);
      submit(json.data);

    } catch (error) {
      console.error('Error fetching Excel data:', error);
    }
  };
  const handleSync = () => {
    setLoading1(true);

    fetchExcelData()
    // setStatusToFree()

  }
  const [Status, setStatus] = useState('')
  const fetchStatus = async () => {
    try {
      // API request
      const response = await fetch('http://192.168.1.46:1337/api/bulkstatuses');
      const data = await response.json();

      // Check if data exists and set the status
      if (data && data.data && data.data[0] && data.data[0].attributes) {
        setStatus(data.data[0].attributes.Status);
      }
    } catch (error) {
      console.error('Error fetching status:', error);
    }
  };
  const setStatusToFree = async () => {
    setLoading(true);
    const res = await fetch('http://192.168.1.46:1337/api/bulkstatuses/1', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: { attributes: { Status: 'free' } } }),
    });
    if (res.ok) setStatus('free');
    setLoading(false);
  };
  const setStatusToworking = async () => {
    setLoading(true);
    const res = await fetch('http://192.168.1.46:1337/api/bulkstatuses/1', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: { attributes: { Status: 'working' } } }),
    });
    if (res.ok) setStatus('working');
    setLoading(false);
  };
  useEffect(() => {
    if (apiData) {
      fetchStatus();
    }
  }, [apiData]);
  const allenrichedProductData = apiData.map(product => {
    const bulkCosting = bulkCostingData.find(
      costing => costing.attributes.ProductCode === product.attributes.ProductCode
    );

    return {
      ...product,
      ProductName: bulkCosting ? bulkCosting.attributes.ProductName : null,
      ProductCode: bulkCosting ? bulkCosting.attributes.ProductCode : null,
      ProductId: bulkCosting ? bulkCosting.attributes.ProductId : null,
      Description: bulkCosting ? bulkCosting.attributes.Description : null,
      createdAt: bulkCosting ? bulkCosting.attributes.createdAt : null,
      updatedAt: bulkCosting ? bulkCosting.attributes.updatedAt : null,
      publishedAt: bulkCosting ? bulkCosting.attributes.publishedAt : null,
      MaterialName: bulkCosting ? bulkCosting.attributes.MaterialName : null,
      AlluminiumWt: bulkCosting ? bulkCosting.attributes.AlluminiumWt : null,
      ThermaPBL: bulkCosting ? bulkCosting.attributes.ThermaPBL : null,
      ThermaPBW: bulkCosting ? bulkCosting.attributes.ThermaPBW : null,
      ThermaPBH: bulkCosting ? bulkCosting.attributes.ThermaPBH : null,
      BaseCostTherma: bulkCosting ? bulkCosting.attributes.BaseCostTherma : null,
      TPPL: bulkCosting ? bulkCosting.attributes.TPPL : null,
      TPPW: bulkCosting ? bulkCosting.attributes.TPPW : null,
      TPPH: bulkCosting ? bulkCosting.attributes.TPPH : null,
      BaseCostPacking: bulkCosting ? bulkCosting.attributes.BaseCostPacking : null,
      ThermaCost: bulkCosting ? bulkCosting.attributes.ThermaCost : null,
      Part1L: bulkCosting ? bulkCosting.attributes.Part1L : null,
      Part1W: bulkCosting ? bulkCosting.attributes.Part1W : null,
      Part1H: bulkCosting ? bulkCosting.attributes.Part1H : null,
      Part2L: bulkCosting ? bulkCosting.attributes.Part2L : null,
      Part2W: bulkCosting ? bulkCosting.attributes.Part2W : null,
      Part2H: bulkCosting ? bulkCosting.attributes.Part2H : null,
      Part3L: bulkCosting ? bulkCosting.attributes.Part3L : null,
      Part3W: bulkCosting ? bulkCosting.attributes.Part3W : null,
      Part3H: bulkCosting ? bulkCosting.attributes.Part3H : null,
      WoodCost: bulkCosting ? bulkCosting.attributes.WoodCost : null,
      WBanai: bulkCosting ? bulkCosting.attributes.WBanai : null,
      WTCost: bulkCosting ? bulkCosting.attributes.WTCost : null,
      WtenperCharge: bulkCosting ? bulkCosting.attributes.WtenperCharge : null,
      Wfiveperwastage: bulkCosting ? bulkCosting.attributes.Wfiveperwastage : null,
      WTCostWastage: bulkCosting ? bulkCosting.attributes.WTCostWastage : null,
      MetalWt: bulkCosting ? bulkCosting.attributes.MetalWt : null,
      Bata_Metal: bulkCosting ? bulkCosting.attributes.Bata_Metal : null,
      MetalCost: bulkCosting ? bulkCosting.attributes.MetalCost : null,
      MetalWastfiveper: bulkCosting ? bulkCosting.attributes.MetalWastfiveper : null,
      MetalWatCost: bulkCosting ? bulkCosting.attributes.MetalWatCost : null,
      GlassWeight: bulkCosting ? bulkCosting.attributes.GlassWeight : null,
      GlassRate: bulkCosting ? bulkCosting.attributes.GlassRate : null,
      GlassTCost: bulkCosting ? bulkCosting.attributes.GlassTCost : null,
      GlassFreight: bulkCosting ? bulkCosting.attributes.GlassFreight : null,
      GlassTCRateFreight: bulkCosting ? bulkCosting.attributes.GlassTCRateFreight : null,
      GlassWasteFivePer: bulkCosting ? bulkCosting.attributes.GlassWasteFivePer : null,
      GlassTCWastage: bulkCosting ? bulkCosting.attributes.GlassTCWastage : null,
      GlassTCFlower: bulkCosting ? bulkCosting.attributes.GlassTCFlower : null,
      FinSize: bulkCosting ? bulkCosting.attributes.FinSize : null,
      FinRate: bulkCosting ? bulkCosting.attributes.FinRate : null,
      FinTotal: bulkCosting ? bulkCosting.attributes.FinTotal : null,
      FinEachprPrice: bulkCosting ? bulkCosting.attributes.FinEachprPrice : null,
      FinFivePerWaste: bulkCosting ? bulkCosting.attributes.FinFivePerWaste : null,
      FinNoOfBallUse: bulkCosting ? bulkCosting.attributes.FinNoOfBallUse : null,
      FinTotalCost: bulkCosting ? bulkCosting.attributes.FinTotalCost : null,
      FinTotall: bulkCosting ? bulkCosting.attributes.FinTotall : null,
      LabNoOfDay: bulkCosting ? bulkCosting.attributes.LabNoOfDay : null,
      LabCost: bulkCosting ? bulkCosting.attributes.LabCost : null,
      LabWasteFivePer: bulkCosting ? bulkCosting.attributes.LabWasteFivePer : null,
      CCML: bulkCosting ? bulkCosting.attributes.CCML : null,
      CCMW: bulkCosting ? bulkCosting.attributes.CCMW : null,
      CCMH: bulkCosting ? bulkCosting.attributes.CCMH : null,
      CCMC: bulkCosting ? bulkCosting.attributes.CCMC : null,
      MSI1I: bulkCosting ? bulkCosting.attributes.MSI1I : null,
      MSI1L: bulkCosting ? bulkCosting.attributes.MSI1L : null,
      MSI1W: bulkCosting ? bulkCosting.attributes.MSI1W : null,
      MSI1H: bulkCosting ? bulkCosting.attributes.MSI1H : null,
      MSI1C: bulkCosting ? bulkCosting.attributes.MSI1C : null,
      MSI2I: bulkCosting ? bulkCosting.attributes.MSI2I : null,
      MSI2L: bulkCosting ? bulkCosting.attributes.MSI2L : null,
      MSI2W: bulkCosting ? bulkCosting.attributes.MSI2W : null,
      MSI2H: bulkCosting ? bulkCosting.attributes.MSI2H : null,
      MSI2C: bulkCosting ? bulkCosting.attributes.MSI2C : null,
      MSINoCost: bulkCosting ? bulkCosting.attributes.MSINoCost : null,
      MSITCostInner: bulkCosting ? bulkCosting.attributes.MSITCostInner : null,
      MSINofPvc: bulkCosting ? bulkCosting.attributes.MSINofPvc : null,
      MSINofPvcBox: bulkCosting ? bulkCosting.attributes.MSINofPvcBox : null,
      MSINofPvcBoxInner: bulkCosting ? bulkCosting.attributes.MSINofPvcBoxInner : null,
      MSITCostInnerr: bulkCosting ? bulkCosting.attributes.MSITCostInnerr : null,
      CCPNoFPiece: bulkCosting ? bulkCosting.attributes.CCPNoFPiece : null,
      CCPCost: bulkCosting ? bulkCosting.attributes.CCPCost : null,
      CCPCBM: bulkCosting ? bulkCosting.attributes.CCPCBM : null,
      FeltSize: bulkCosting ? bulkCosting.attributes.FeltSize : null,
      FeltRate: bulkCosting ? bulkCosting.attributes.FeltRate : null,
      FeltCost: bulkCosting ? bulkCosting.attributes.FeltCost : null,
      PlateWeight: bulkCosting ? bulkCosting.attributes.PlateWeight : null,
      PlateRate: bulkCosting ? bulkCosting.attributes.PlateRate : null,
      PlateCost: bulkCosting ? bulkCosting.attributes.PlateCost : null,
      PPNSize: bulkCosting ? bulkCosting.attributes.PPNSize : null,
      PPNRate: bulkCosting ? bulkCosting.attributes.PPNRate : null,
      PPNCost: bulkCosting ? bulkCosting.attributes.PPNCost : null,
      PALength: bulkCosting ? bulkCosting.attributes.PALength : null,
      PARate: bulkCosting ? bulkCosting.attributes.PARate : null,
      PACost: bulkCosting ? bulkCosting.attributes.PACost : null,
      NikSize: bulkCosting ? bulkCosting.attributes.NikSize : null,
      NikRate: bulkCosting ? bulkCosting.attributes.NikRate : null,
      NikCost: bulkCosting ? bulkCosting.attributes.NikCost : null,
      CBNSize: bulkCosting ? bulkCosting.attributes.CBNSize : null,
      CBNRate: bulkCosting ? bulkCosting.attributes.CBNRate : null,
      CBNCost: bulkCosting ? bulkCosting.attributes.CBNCost : null,
      Bubble: bulkCosting ? bulkCosting.attributes.Bubble : null,
      LabForSheet: bulkCosting ? bulkCosting.attributes.LabForSheet : null,
      TransCBM: bulkCosting ? bulkCosting.attributes.TransCBM : null,
      TransPPCBM: bulkCosting ? bulkCosting.attributes.TransPPCBM : null,
      TransCost: bulkCosting ? bulkCosting.attributes.TransCost : null,
      TransCost_Overhead: bulkCosting ? bulkCosting.attributes.TransCost_Overhead : null,
      TotalwithMargin: bulkCosting ? bulkCosting.attributes.TotalwithMargin : null,
      TotalPriceUSD: bulkCosting ? bulkCosting.attributes.TotalPriceUSD : null,
      TotalPriceUSD1: bulkCosting ? bulkCosting.attributes.TotalPriceUSD1 : null,
    };
  });
  const handleSendProductNames = async () => {
    setLoading(true);
    // setStatusToworking()
    try {
      // Step 1: Fetch the current data from the Google Sheet
      const sheetData = excelData;

      // Step 2: Filter new products that are not in the Google Sheet
      const newProducts = apiData
        .map((item, index) => ({
          ProductImage: item.attributes.CoverImage?.data?.attributes?.url ? `=IMAGE("${`${globalIP}` + item.attributes.CoverImage?.data?.attributes?.url}", 4, 50, 50)` : 'No Image',
          id: item.id,
          ProductName: item.attributes.ProductName,
          ProductCode: item.attributes.ProductCode,
          DesignNo: String(item.attributes.ProductId),
          Description: item.attributes.Description,
          ThermaPBL: item.attributes.Length,
          ThermaPBW: item.attributes.Width,
          ThermaPBH: item.attributes.Height,
          Color: item.attributes.ColorName
        }))

      console.log("came till herer")

      newProducts.forEach((product, index) => {
        // Find the corresponding enriched product by ProductId
        const enrichedProduct = allenrichedProductData.find(
          ep => ep.attributes.ProductId == product.DesignNo
        );

        if (enrichedProduct) {
          product.SrNo = index + 1
          // Add enriched data to the product
          product.AlluminiumWt = enrichedProduct.AlluminiumWt;
          product.TotalPriceUSD = enrichedProduct.TotalPriceUSD;

          product.ThermaProductBaseLength = enrichedProduct.ThermaPBL || product.ThermaPBL
          product.ThermaProductBaseWidth = enrichedProduct.ThermaPBW || product.ThermaPBW
          product.ThermaProductBaseHeight = enrichedProduct.ThermaPBH || product.ThermaPBH
          // Add more attributes from enrichedProduct
          product.ThermaBaseCost = `=((G${index + 2}*H${index + 2}*I${index + 2})/500000000)*1200`
          product.ThermaProductPackingLength = enrichedProduct.TPPL
          product.ThermaProductPackingWidth = enrichedProduct.TPPW
          product.ThermaProductPackingHeight = enrichedProduct.TPPH
          product.PackingBaseCost = `=((K${index + 2}*L${index + 2}*M${index + 2})/500000000)*1200`
          product.ThermaCost = `=SUM(J${index + 2}+N${index + 2})`
          product.Part1L = enrichedProduct.Part1L
          product.Part1W = enrichedProduct.Part1W
          product.Part1H = enrichedProduct.Part1H
          product.Part2L = enrichedProduct.Part2L
          product.Part2W = enrichedProduct.Part2W
          product.Part2H = enrichedProduct.Part2H
          product.Part3L = enrichedProduct.Part3L
          product.Part3W = enrichedProduct.Part3W
          product.Part3H = enrichedProduct.Part3H
          product.WoodCost = enrichedProduct.WoodCost
          product.WBanai = enrichedProduct.WBanai
          product.WTCost = enrichedProduct.WTCost
          product.WtenperCharge = enrichedProduct.WtenperCharge
          product.Wfiveperwastage = enrichedProduct.Wfiveperwastage
          product.WTCostWastage = enrichedProduct.WTCostWastage
          product.MetalWt = enrichedProduct.MetalWt
          product.Bata_Metal = enrichedProduct.Bata_Metal
          product.MetalCost = enrichedProduct.MetalCost
          product.MetalWastfiveper = enrichedProduct.MetalWastfiveper
          product.MetalWatCost = enrichedProduct.MetalWatCost
          product.GlassWeight = enrichedProduct.GlassWeight
          product.GlassRate = enrichedProduct.GlassRate
          product.GlassTCost = enrichedProduct.GlassTCost
          product.GlassFreight = enrichedProduct.GlassFreight
          product.GlassTCRateFreight = enrichedProduct.GlassTCRateFreight
          product.GlassWasteFivePer = enrichedProduct.GlassWasteFivePer
          product.GlassTCWastage = enrichedProduct.GlassTCWastage
          product.GlassTCFlower = enrichedProduct.GlassTCFlower
          product.FinSize = enrichedProduct.FinSize
          product.FinRate = enrichedProduct.FinRate
          product.FinTotal = enrichedProduct.FinTotal
          product.FinEachprPrice = enrichedProduct.FinEachprPrice
          product.FinFivePerWaste = enrichedProduct.FinFivePerWaste
          product.FinNoOfBallUse = enrichedProduct.FinNoOfBallUse
          product.FinTotalCost = enrichedProduct.FinTotalCost
          product.FinTotall = enrichedProduct.FinTotall
          product.LabNoOfDay = enrichedProduct.LabNoOfDay
          product.LabCost = enrichedProduct.LabCost
          product.LabWasteFivePer = enrichedProduct.LabWasteFivePer
          product.CCML = enrichedProduct.CCML
          product.CCMW = enrichedProduct.CCMW
          product.CCMH = enrichedProduct.CCMH
          product.CCMC = enrichedProduct.CCMC
          product.MSI1I = enrichedProduct.MSI1I
          product.MSI1L = enrichedProduct.MSI1L
          product.MSI1W = enrichedProduct.MSI1W
          product.MSI1H = enrichedProduct.MSI1H
          product.MSI1C = enrichedProduct.MSI1C
          product.MSI2I = enrichedProduct.MSI2I
          product.MSI2L = enrichedProduct.MSI2L
          product.MSI2W = enrichedProduct.MSI2W
          product.MSI2H = enrichedProduct.MSI2H
          product.MSI2C = enrichedProduct.MSI2C
          product.MSINoCost = enrichedProduct.MSINoCost
          product.MSITCostInner = enrichedProduct.MSITCostInner
          product.MSINofPvc = enrichedProduct.MSINofPvc
          product.MSINofPvcBox = enrichedProduct.MSINofPvcBox
          product.MSINofPvcBoxInner = enrichedProduct.MSINofPvcBoxInner
          product.MSITCostInnerr = enrichedProduct.MSITCostInnerr
          product.CCPNoFPiece = enrichedProduct.CCPNoFPiece
          product.CCPCost = enrichedProduct.CCPCost
          product.CCPCBM = enrichedProduct.CCPCBM
          product.FeltSize = enrichedProduct.FeltSize
          product.FeltRate = enrichedProduct.FeltRate
          product.FeltCost = enrichedProduct.FeltCost
          product.PlateWeight = enrichedProduct.PlateWeight
          product.PlateRate = enrichedProduct.PlateRate
          product.PlateCost = enrichedProduct.PlateCost
          product.PPNSize = enrichedProduct.PPNSize
          product.PPNRate = enrichedProduct.PPNRate
          product.PPNCost = enrichedProduct.PPNCost
          product.PALength = enrichedProduct.PALength
          product.PARate = enrichedProduct.PARate
          product.PACost = enrichedProduct.PACost
          product.NikSize = enrichedProduct.NikSize
          product.NikRate = enrichedProduct.NikRate
          product.NikCost = enrichedProduct.NikCost
          product.CBNSize = enrichedProduct.CBNSize
          product.CBNRate = enrichedProduct.CBNRate
          product.CBNCost = enrichedProduct.CBNCost
          product.Bubble = enrichedProduct.Bubble
          product.LabForSheet = enrichedProduct.LabForSheet
          product.TransCBM = enrichedProduct.TransCBM
          product.TransPPCBM = enrichedProduct.TransPPCBM
          product.TransCost = enrichedProduct.TransCost
          product.TransCost_Overhead = enrichedProduct.TransCost_Overhead
          product.TotalwithMargin = enrichedProduct.TotalwithMargin
          product.TotalPriceUSD = enrichedProduct.TotalPriceUSD
          product.TotalPriceUSD1 = enrichedProduct.TotalPriceUSD1
        }
      });
      console.log('newProducts', newProducts);
      // return 0;
      // Step 3: Post only new products to the Google Sheet
      if ((excelData.length == 0) && (meta123.pagination.total == 0)) {
        toaster.push(
          <Message showIcon type="info">
            Excel is already cleared
          </Message>,
          { placement: 'topEnd' }
        );
      } else {

        if (meta123.pagination.total == 0) {
          try {
            await fetch('https://sheetdb.io/api/v1/xuci4fdh8xjue/all', {
              method: 'DELETE',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            })
              .then((response) => response.json())

            toaster.push(
              <Message showIcon type="info">
                Excel Cleared Successfully
              </Message>,
              { placement: 'topEnd' }
            );

          } catch (error) {
            console.error(error);
          }

        }
        else {


          if (newProducts.length > 0) {
            await fetch('https://sheetdb.io/api/v1/xuci4fdh8xjue/all', {
              method: 'DELETE',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            })
              .then((response) => response.json())
              .then(async (data) => {
                console.log(data)
                await axios.post('https://sheetdb.io/api/v1/xuci4fdh8xjue', newProducts);
                console.log('New products added:', newProducts);
                toaster.push(
                  <Message showIcon type="success">
                    Data Saved Successfully!
                  </Message>,
                  { placement: 'topEnd' }
                );
              });
            toaster.push(
              <Message showIcon type="success">
                Successfully sent data to excel
              </Message>,
              { placement: 'topEnd' }
            );
            removeSheetBGColor()
            // handleOpenGlink(); // If needed to open the Google Sheet or perform any other action
          } else {
            toaster.push(
              <Message showIcon type="info">
                No new products to add.
              </Message>,
              { placement: 'topEnd' }
            );
          }
        }
      }

    } catch (error) {
      console.error('Error sending data:', error);
      toaster.push(
        <Message showIcon type="error">
          Error Sending Data.
        </Message>,
        { placement: 'topEnd' }
      );
    } finally {
      setLoading(false);
    }
  };
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);

  const submit = async (excelData) => {

    setLoading1(true);

    // First, fetch all existing bulks-costings entries
    let checkData = [];
    let page = 1;
    let totalPages = 1; // Start with the first page

    try {
      // Keep fetching data while we have more pages
      while (page <= totalPages) {
        const checkResponse = await fetch(`${ip}/api/bulks-costings?pagination[page]=${page}`);
        const responseData = await checkResponse.json();

        // Assuming the response contains data and meta fields
        checkData = [...checkData, ...responseData.data];  // Append the data to checkData

        // Update pagination info from the response
        totalPages = responseData.meta.pagination.pageCount;
        page++;  // Move to the next page
      }
    } catch (error) {
      console.error('Error fetching existing bulks-costings:', error);
      setLoading1(false);
      return;
    }
    console.log('checkData', checkData);
    // Extract the ProductId from the selected products (excelData)
    const selectedProductIds = excelData.map(product => product.ProductId);

    // Loop through all existing entries and delete the ones that are not in the selected products
    for (const existingEntry of checkData) {
      if (!selectedProductIds.includes(existingEntry.attributes.ProductId)) {
        try {
          const deleteResponse = await fetch(`${ip}/api/bulks-costings/${existingEntry.id}`, {
            method: 'DELETE',
          });
          const deleteData = await deleteResponse.json();
          // console.log('Deleted unused product:', deleteData);
        } catch (error) {
          console.error(`Error deleting product with ID ${existingEntry.id}:`, error);
        }
      }
    }

    // Now iterate over the selected products and either update or add new entries
    for (const selectedProduct of excelData) {
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          ProductName: selectedProduct.ProductName,
          ProductCode: selectedProduct.ProductCode,
          ProductId: String(selectedProduct.ProductId),
          Description: selectedProduct.Description,
          MaterialName: selectedProduct.MaterialName,
          AlluminiumWt: Number(selectedProduct.AlluminiumWt),
          ThermaPBL: Number(selectedProduct.ThermaPBL),
          ThermaPBW: Number(selectedProduct.ThermaPBW),
          ThermaPBH: Number(selectedProduct.ThermaPBH),
          BaseCostTherma: Number(selectedProduct.BaseCostTherma),
          TPPL: Number(selectedProduct.TPPL),
          TPPW: Number(selectedProduct.TPPW),
          TPPH: Number(selectedProduct.TPPH),
          BaseCostPacking: Number(selectedProduct.BaseCostPacking),
          ThermaCost: Number(selectedProduct.ThermaCost),
          Part1L: Number(selectedProduct.Part1L),
          Part1W: Number(selectedProduct.Part1W),
          Part1H: Number(selectedProduct.Part1H),
          Part2L: Number(selectedProduct.Part2L),
          Part2W: Number(selectedProduct.Part2W),
          Part2H: Number(selectedProduct.Part2H),
          Part3L: Number(selectedProduct.Part3L),
          Part3W: Number(selectedProduct.Part3W),
          Part3H: Number(selectedProduct.Part3H),
          WoodCost: Number(selectedProduct.WoodCost),
          WBanai: Number(selectedProduct.WBanai),
          WTCost: Number(selectedProduct.WTCost),
          WtenperCharge: Number(selectedProduct.WtenperCharge),
          Wfiveperwastage: Number(selectedProduct.Wfiveperwastage),
          WTCostWastage: Number(selectedProduct.WTCostWastage),
          MetalWt: Number(selectedProduct.MetalWt),
          Bata_Metal: Number(selectedProduct.Bata_Metal),
          MetalCost: Number(selectedProduct.MetalCost),
          MetalWastfiveper: Number(selectedProduct.MetalWastfiveper),
          MetalWatCost: Number(selectedProduct.MetalWatCost),
          GlassWeight: Number(selectedProduct.GlassWeight),
          GlassRate: Number(selectedProduct.GlassRate),
          GlassTCost: Number(selectedProduct.GlassTCost),
          GlassFreight: Number(selectedProduct.GlassFreight),
          GlassTCRateFreight: Number(selectedProduct.GlassTCRateFreight),
          GlassWasteFivePer: Number(selectedProduct.GlassWasteFivePer),
          GlassTCWastage: Number(selectedProduct.GlassTCWastage),
          GlassTCFlower: Number(selectedProduct.GlassTCFlower),
          FinSize: selectedProduct.FinSize,
          FinRate: Number(selectedProduct.FinRate),
          FinTotal: Number(selectedProduct.FinTotal),
          FinEachprPrice: Number(selectedProduct.FinEachprPrice),
          FinFivePerWaste: Number(selectedProduct.FinFivePerWaste),
          FinNoOfBallUse: Number(selectedProduct.FinNoOfBallUse),
          FinTotalCost: Number(selectedProduct.FinTotalCost),
          FinTotall: Number(selectedProduct.FinTotall),
          LabNoOfDay: Number(selectedProduct.LabNoOfDay),
          LabCost: Number(selectedProduct.LabCost),
          LabWasteFivePer: Number(selectedProduct.LabWasteFivePer),
          CCML: Number(selectedProduct.CCML),
          CCMW: Number(selectedProduct.CCMW),
          CCMH: Number(selectedProduct.CCMH),
          CCMC: Number(selectedProduct.CCMC),
          MSI1I: selectedProduct.MSI1I,
          MSI1L: Number(selectedProduct.MSI1L),
          MSI1W: Number(selectedProduct.MSI1W),
          MSI1H: Number(selectedProduct.MSI1H),
          MSI1C: Number(selectedProduct.MSI1C),
          MSI2I: selectedProduct.MSI2I,
          MSI2L: Number(selectedProduct.MSI2L),
          MSI2W: Number(selectedProduct.MSI2W),
          MSI2H: Number(selectedProduct.MSI2H),
          MSI2C: Number(selectedProduct.MSI2C),
          MSINoCost: Number(selectedProduct.MSINoCost),
          MSITCostInner: Number(selectedProduct.MSITCostInner),
          MSINofPvc: Number(selectedProduct.MSINofPvc),
          MSINofPvcBox: Number(selectedProduct.MSINofPvcBox),
          MSINofPvcBoxInner: Number(selectedProduct.MSINofPvcBoxInner),
          MSITCostInnerr: Number(selectedProduct.MSITCostInnerr),
          CCPNoFPiece: Number(selectedProduct.CCPNoFPiece),
          CCPCost: Number(selectedProduct.CCPCost),
          CCPCBM: Number(selectedProduct.CCPCBM),
          FeltSize: selectedProduct.FeltSize,
          FeltRate: Number(selectedProduct.FeltRate),
          FeltCost: Number(selectedProduct.FeltCost),
          PlateWeight: Number(selectedProduct.PlateWeight),
          PlateRate: Number(selectedProduct.PlateRate),
          PlateCost: Number(selectedProduct.PlateCost),
          PPNSize: selectedProduct.PPNSize,
          PPNRate: Number(selectedProduct.PPNRate),
          PPNCost: Number(selectedProduct.PPNCost),
          PALength: Number(selectedProduct.PALength),
          PARate: Number(selectedProduct.PARate),
          PACost: Number(selectedProduct.PACost),
          NikSize: selectedProduct.NikSize,
          NikRate: Number(selectedProduct.NikRate),
          NikCost: Number(selectedProduct.NikCost),
          CBNSize: selectedProduct.CBNSize,
          CBNRate: Number(selectedProduct.CBNRate),
          CBNCost: Number(selectedProduct.CBNCost),
          Bubble: selectedProduct.Bubble,
          LabForSheet: Number(selectedProduct.LabForSheet),
          TransCBM: Number(selectedProduct.TransCBM),
          TransPPCBM: Number(selectedProduct.TransPPCBM),
          TransCost: Number(selectedProduct.TransCost),
          TransCost_Overhead: Number(selectedProduct.TransCost_Overhead),
          TotalwithMargin: Number(selectedProduct.TotalwithMargin),
          TotalPriceUSD: Number(selectedProduct.TotalPriceUSD),
          TotalPriceUSD1: Number(selectedProduct.TotalPriceUSD1)
          // Continue adding other fields as needed...
        })
      );

      try {
        // Check if the product exists
        const checkResponse = await fetch(
          `${ip}/api/bulks-costings?filters[ProductId][$eq]=${selectedProduct.ProductId}`
        );
        const checkData = await checkResponse.json();

        if (checkData.data.length > 0) {
          // Product exists, perform an update
          const productId = checkData.data[0].id;
          const updateResponse = await fetch(`${ip}/api/bulks-costings/${productId}`, {
            method: 'PUT',
            body: formData
          });
          const updateData = await updateResponse.json();
          // console.log('Updated product:', updateData);
        } else {
          // Product doesn't exist, create a new entry
          try {
            const addResponse = await fetch(`${ip}/api/bulks-costings`, {
              method: 'POST',
              body: formData
            });

            if (!addResponse.ok) {
              // Handle non-OK HTTP responses (e.g., 400, 500)
              const errorResponse = await addResponse.json();
              throw new Error(`At Product Id ${selectedProduct.ProductId} : ` + errorResponse.error?.message || 'Something went wrong');
            }

            const addData = await addResponse.json();
            console.log('Added new product:', addData);
          } catch (error) {
            // Extract the error message from the caught error and display it in the toaster
            toaster.push(
              <Message showIcon type="warning">
                {error.message}
              </Message>,
              { placement: 'topEnd' }
            );
          }


        }
      } catch (error) {
        console.error('Error processing product:', error);
      }
    }
    fetchbulkdata()
    setLoading1(false);
  };


  // Fetch data when the component mounts
  useEffect(() => {
    fetchAlldata();
    // fetchExcelData();
  }, []);

  // Submit form when Excel data changes
  useEffect(() => {

    // submit(); // Automatically submit when data is fetched or changed

  }, [excelData, apiData]);
  const [link, setLink] = useState(
    'https://docs.google.com/spreadsheets/d/1FEnc0ZPSvcb1_OkT_cTu8I-FNTChLinzH5sbe5yo3gM/edit?gid=0#gid=0'
  );
  const [openGlink, setOpenGlink] = useState(false);
  const handleCloseGlink = () => setOpenGlink(false);

  const [isCopied, setIsCopied] = useState(false);
  const handleCopy = () => {
    setIsCopied(true);
  };
  return (
    <>
      <Container className="main">
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <h3 className="title">Bulk Costing</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Bulk Costing</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={5} className={openSet ? 'mange-item' : 'mange-search'}>
              {head.some(item => item.FilterName === 'Category' && item.filterstatus == true) && (
                <CheckPicker
                  data={categorydata}
                  placeholder={`Select ${label[0]?.attributes.Category}`}
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  style={{ width: 145 }}
                  onOpen={fetchDatac}
                  menuStyle={{ maxWidth: 250 }}
                />
              )}
              {head.some(
                item => item.FilterName === 'ProductType' && item.filterstatus == true
              ) && (
                  <CheckPicker
                    data={productypedata}
                    placeholder={`Select ${label[0]?.attributes.ProductType}`}
                    value={excelProductType}
                    onChange={handleProductTypeChange}
                    style={{ width: 145 }}
                    menuStyle={{ maxWidth: 250 }}
                  />
                )}
              {head.some(item => item.FilterName === 'Color' && item.filterstatus == true) && (
                <CheckPicker
                  data={colordata}
                  placeholder={`Select ${label[0]?.attributes.color}`}
                  value={selectedColor}
                  onChange={handleColorChange}
                  style={{ width: 145 }}
                  onOpen={fetchData5}
                  menuStyle={{ maxWidth: 250 }}
                />
              )}
              {head.some(item => item.FilterName === 'ProName' && item.filterstatus == true) && (
                <CheckPicker
                  value={selectedpron}
                  onChange={handleProNameChange}
                  data={proNamedata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.ProductName}`}
                  style={{ width: 145 }}
                  menuStyle={{ maxWidth: 250 }}
                />
              )}
              {head.some(item => item.FilterName === 'Finish' && item.filterstatus == true) && (
                <CheckPicker
                  value={selectedFinish}
                  onChange={handleFinishChange}
                  data={finishdata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.finish}`}
                  style={{ width: 145 }}
                  onOpen={fetchData4}
                  menuStyle={{ maxWidth: 250 }}
                />
              )}
              {head.some(item => item.FilterName === 'AliasCode' && item.filterstatus == true) && (
                <CheckPicker
                  data={aliasdata}
                  placeholder={`Select ${label[0]?.attributes.AliasCode}`}
                  placement="autoVerticalStart"
                  value={selectedAlias}
                  onChange={handleAliasChange}
                  style={{ width: 145 }}
                  menuStyle={{ maxWidth: 250 }}
                />
              )}
              {head.some(item => item.FilterName === 'SearchK' && item.filterstatus == true) && (
                <CheckPicker
                  value={selectedSearch}
                  onChange={handleSearchChange}
                  data={searchdata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.searchKeyword}`}
                  style={{ width: 145 }}
                  menuStyle={{ maxWidth: 250 }}
                />
              )}
              {head.some(item => item.FilterName === 'PDesign' && item.filterstatus == true) && (
                <CheckPicker
                  value={selectedpd}
                  onChange={handleProDChange}
                  data={proDdata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.ProductDesigner}`}
                  style={{ width: 145 }}
                  menuStyle={{ maxWidth: 250 }}
                />
              )}
              {head.some(item => item.FilterName === 'MadeBy' && item.filterstatus == true) && (
                <CheckPicker
                  value={selectedmade}
                  onChange={handleMadeChange}
                  data={madedata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.MadeBy}`}
                  style={{ width: 145 }}
                  menuStyle={{ maxWidth: 250 }}
                />
              )}
              {head.some(item => item.FilterName === 'HSN' && item.filterstatus == true) && (
                <CheckPicker
                  value={selectedhsn}
                  onChange={handleHSNChange}
                  data={hsndata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.HSN}`}
                  style={{ width: 145 }}
                  onOpen={fetchData6}
                  menuStyle={{ maxWidth: 250 }}
                />
              )}
              {head.some(item => item.FilterName === 'BuyerName' && item.filterstatus == true) && (
                <CheckPicker
                  value={selectedBuyer}
                  onChange={handleBuyerChange}
                  data={buyernamedata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.BuyerName}`}
                  style={{ width: 145 }}
                  menuStyle={{ maxWidth: 250 }}
                />
              )}
              {head.some(item => item.FilterName === 'BuyerStyle' && item.filterstatus == true) && (
                <CheckPicker
                  value={selectedsku}
                  onChange={handleSkuChange}
                  data={skudata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.BuyerSku}`}
                  style={{ width: 145 }}
                  menuStyle={{ maxWidth: 250 }}
                />
              )}

              <Button appearance="default" active onClick={() => setShowDrawer(true)}>
                More Filter
              </Button>
            </Stack>
          </Stack>
          <Stack direction="column" alignItems="flex-end" style={{ marginTop: '8px' }}>
            <Stack spacing={5}>
              {/* <Checkbox
                indeterminate={selectedItems.length > 0 && selectedItems.length < data123.length}
                checked={
                  selectedItems.length === (filtersApplied ? applyFilters().length : data123.length)
                }
                onChange={handleCheckAll}
              >
                Select all
              </Checkbox> */}
              <br />
            </Stack>
            <Stack direction="row" spacing={2} className="selection-search">
              <InputGroup inside>
                <Input
                  placeholder="Search"
                  type="text"
                  value={searchQuery}
                  onChange={handleSearch}
                />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
            </Stack>
            <Stack spacing={6}>
              <a href={link} target="_blank" rel="noopener noreferrer">
                <Button appearance="ghost" color="green" style={{ marginTop: '6px', marginBottom: '5px' }}>
                  Costing Sheet
                </Button>
              </a>
              <Whisper speaker={<Tooltip>Sync Data</Tooltip>} placement='auto'>
                <IconButton icon={<ReloadIcon />} loading={loading} onClick={handleSendProductNames} />
              </Whisper>
              <Whisper speaker={<Tooltip>Fetch Data</Tooltip>} placement='auto'>
                <IconButton icon={<ReloadIcon style={{ transform: 'rotate(180deg)', transition: 'transform 0.3s ease' }} />} loading={loading1} onClick={handleSync} />
              </Whisper>
            </Stack>
          </Stack>
        </Stack>
        <Divider style={{ marginTop: '16px' }} />
        <div className="cat-row-image">
          <Panel>
            {(selectedCategory.length > 0 ||
              selectedColor.length > 0 ||
              selectedFinish.length > 0 ||
              selectedhsn.length > 0 ||
              selectedBuyer.length > 0 ||
              selectedSearch.length > 0 ||
              selectedAlias.length > 0 ||
              selectedpron.length > 0 ||
              selectedpd.length > 0 ||
              selectedmade.length > 0 ||
              selectedsku.length > 0) ? (
              <b style={{ marginLeft: '6px' }}>
                Total Products: {data123.length}/{meta123?.pagination?.total}
              </b>
            ) :
              <b style={{ marginLeft: '6px' }}>Total Products: {data123.length}/{meta123?.pagination?.total}</b>
            }

            <Table
              virtualized
              wordWrap="break-word"
              shouldUpdateScroll={false}
              loading={isLoading}
              rowHeight={60}
              cellBordered
              data={
                noData
                  ? []
                  : enrichedProductData
              }
              height={450}
              rowKey="id"
              onRowClick={() => { }}
              bordered
            >
              {defaultColumns.map(column => {
                if (columnKeys.includes(column.key)) {
                  const { key, label, headerCell, cell, ...rest } = column;
                  return (
                    <Table.Column {...rest} key={key} align="center">
                      {headerCell || <CustomHeaderCell>{label}</CustomHeaderCell>}
                      {cell || <CustomCell dataKey={key} />}
                    </Table.Column>
                  );
                }
                return null;
              })}
            </Table>
            <div style={{ padding: 20 }}>
              <Pagination
                prev
                next
                limit={25}
                first
                last
                ellipsis
                boundaryLinks
                maxButtons={5}
                size="sm"
                layout={['total', '-', 'pager', 'skip']}
                total={meta123?.pagination?.total || 0}
                activePage={page}
                onChangePage={setPage}
                onChangeLimit={handleChangeLimit}
              />
            </div>
          </Panel>
        </div>
        <Drawer size="xs" backdrop="static" open={showDrawer} onClose={() => setShowDrawer(false)}>
          <Drawer.Header>
            <Drawer.Title>Filters</Drawer.Title>
            <Drawer.Actions>
              <Button onClick={() => setShowDrawer(false)} appearance="primary" color="cyan">
                Confirm
              </Button>
            </Drawer.Actions>
          </Drawer.Header>
          <Drawer.Body>
            <Stack direction="column" alignItems="center">
              <br />
              {head.some(item => item.FilterName === 'Category' && item.filterstatus == false) && (
                <CheckPicker
                  data={categorydata}
                  placeholder={`Select ${label[0]?.attributes.Category}`}
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  style={{ width: 350, marginBottom: 20, marginTop: 20 }}
                  onOpen={fetchDatac}
                />
              )}
              {head.some(
                item => item.FilterName === 'ProductType' && item.filterstatus == false
              ) && (
                  <CheckPicker
                    data={productypedata}
                    placeholder={`Select ${label[0]?.attributes.ProductType}`}
                    value={excelProductType}
                    onChange={handleProductTypeChange}
                    style={{ width: 350, marginBottom: 20 }}
                  />
                )}
              {head.some(item => item.FilterName === 'Color' && item.filterstatus == false) && (
                <CheckPicker
                  data={colordata}
                  placeholder={`Select ${label[0]?.attributes.color}`}
                  value={selectedColor}
                  onChange={handleColorChange}
                  style={{ width: 350, marginBottom: 20 }}
                  onOpen={fetchData5}
                />
              )}
              {head.some(item => item.FilterName === 'ProName' && item.filterstatus == false) && (
                <CheckPicker
                  renderMenu={renderMenu2}
                  value={selectedpron}
                  onChange={handleProNameChange}
                  data={proNamedata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.ProductName}`}
                  style={{ width: 350, marginBottom: 20 }}
                />
              )}
              {head.some(
                item => item.FilterName === 'BuyerStyle' && item.filterstatus == false
              ) && (
                  <CheckPicker
                    renderMenu={renderMenu5}
                    value={selectedsku}
                    onChange={handleSkuChange}
                    data={skudata}
                    placement="autoVerticalStart"
                    placeholder={`Select ${label[0]?.attributes.BuyerSku}`}
                    style={{ width: 350, marginBottom: 20 }}
                  />
                )}
              {head.some(item => item.FilterName === 'BuyerName' && item.filterstatus == false) && (
                <CheckPicker
                  value={selectedBuyer}
                  onChange={handleBuyerChange}
                  data={buyernamedata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.BuyerName}`}
                  style={{ width: 350, marginBottom: 20 }}
                />
              )}
              {head.some(item => item.FilterName === 'Finish' && item.filterstatus == false) && (
                <CheckPicker
                  value={selectedFinish}
                  onChange={handleFinishChange}
                  data={finishdata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.finish}`}
                  style={{ width: 350, marginBottom: 20 }}
                  onOpen={fetchData4}
                />
              )}
              {head.some(item => item.FilterName === 'AliasCode' && item.filterstatus == false) && (
                <CheckPicker
                  data={aliasdata}
                  placeholder={`Select ${label[0]?.attributes.AliasCode}`}
                  placement="autoVerticalStart"
                  value={selectedAlias}
                  onChange={handleAliasChange}
                  style={{ width: 350, marginBottom: 20 }}
                  renderMenu={renderMenu1}
                />
              )}
              {head.some(item => item.FilterName === 'SearchK' && item.filterstatus == false) && (
                <CheckPicker
                  renderMenu={renderMenu}
                  value={selectedSearch}
                  onChange={handleSearchChange}
                  data={searchdata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.searchKeyword}`}
                  style={{ width: 350, marginBottom: 20 }}
                />
              )}
              {head.some(item => item.FilterName === 'PDesign' && item.filterstatus == false) && (
                <CheckPicker
                  renderMenu={renderMenu3}
                  value={selectedpd}
                  onChange={handleProDChange}
                  data={proDdata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.ProductDesigner}`}
                  style={{ width: 350, marginBottom: 20 }}
                />
              )}
              {head.some(item => item.FilterName === 'MadeBy' && item.filterstatus == false) && (
                <CheckPicker
                  renderMenu={renderMenu4}
                  value={selectedmade}
                  onChange={handleMadeChange}
                  data={madedata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.MadeBy}`}
                  style={{ width: 350, marginBottom: 20 }}
                />
              )}
              {head.some(item => item.FilterName === 'HSN' && item.filterstatus == false) && (
                <CheckPicker
                  value={selectedhsn}
                  onChange={handleHSNChange}
                  data={hsndata}
                  placement="autoVerticalStart"
                  placeholder={`Select ${label[0]?.attributes.HSN}`}
                  style={{ width: 350, marginBottom: 20 }}
                  onOpen={fetchData6}
                />
              )}
            </Stack>
          </Drawer.Body>
        </Drawer>
        <Modal
          size={window.innerWidth >= 746 ? 'full' : 'calc(100% - -7px)'}
          open={open}
          onClose={handleClose}
        >
          <Modal.Header>
            <Modal.Title>
              <h5>Product Details</h5>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: '0px' }}>
            <Swiper
              navigation={true}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
              }}
              pagination={{
                clickable: true
              }}
              modules={[EffectFade, Navigation]}
              className="mySwiper-1"
            >
              {modeldata?.map((item, index) => {
                return (
                  <SwiperSlide key={item.id}>
                    <Grid fluid>
                      <Row>
                        <Col lg={12} xs={24}>
                          <div className="slide-main-image">
                            <img
                              src={
                                selectedImagePath.url && selectedImagePath.id == item.id
                                  ? `${globalIP}${selectedImagePath.url}`
                                  : `${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`
                              }
                              alt=""
                              className="iiimge"
                            />
                          </div>
                          {!item.attributes.MultipleImage.data && (
                            <div style={{ padding: '15px 50px' }}>
                              <Swiper
                                spaceBetween={20}
                                navigation={true}
                                slidesPerView={window.innerWidth >= 746 ? 6 : 3}
                                pagination={{ clickable: true }}
                                modules={[Navigation]}
                                className="nestedSwiper"
                              >
                                <SwiperSlide>
                                  <div
                                    style={{
                                      // height: '80px',
                                      borderRadius: '5px',
                                      overflow: 'hidden'
                                    }}
                                  >
                                    <img
                                      src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                                      alt=""
                                      style={{ width: '100%', height: '100%' }}
                                      onClick={() =>
                                        setSelectedImagePath({
                                          url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                          id: item.id,
                                          default: true
                                        })
                                      }
                                    />
                                  </div>
                                </SwiperSlide>
                              </Swiper>
                            </div>
                          )}
                          {item.attributes.MultipleImage.data && (
                            <div style={{ padding: '15px 10px' }}>
                              <Swiper
                                spaceBetween={20}
                                navigation={true}
                                slidesPerView={window.innerWidth >= 746 ? 6 : 3}
                                pagination={{ clickable: true }}
                                modules={[Navigation]}
                                className="nestedSwiper"
                              >
                                <SwiperSlide>
                                  <div
                                    style={{
                                      height: '80px',
                                      borderRadius: '5px',
                                      overflow: 'hidden'
                                    }}
                                    className={
                                      selectedImagePath.url ==
                                        item?.attributes?.CoverImage?.data?.attributes?.url &&
                                        selectedImagePath.id == item.id
                                        ? 'image-product-select image-product-select-active'
                                        : null
                                    }
                                  >
                                    <img
                                      src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                                      alt=""
                                      style={{ width: '100%', height: '100%' }}
                                      onClick={() =>
                                        setSelectedImagePath({
                                          url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                          id: item.id,
                                          default: true
                                        })
                                      }
                                    />
                                  </div>
                                </SwiperSlide>
                                {item.attributes.MultipleImage.data &&
                                  item.attributes.MultipleImage.data.map(multiImage => {
                                    return (
                                      <SwiperSlide key={multiImage.id}>
                                        <div
                                          style={{
                                            height: '80px',
                                            borderRadius: '5px',
                                            overflow: 'hidden'
                                          }}
                                          className={
                                            selectedImagePath.url == multiImage.attributes.url &&
                                              selectedImagePath.id == item.id
                                              ? 'image-product-select image-product-select-active'
                                              : null
                                          }
                                        >
                                          <img
                                            src={`${globalIP}${multiImage.attributes.url}`}
                                            alt=""
                                            style={{ width: '100%', height: '100%' }}
                                            onClick={() =>
                                              setSelectedImagePath({
                                                url: multiImage.attributes.url,
                                                id: item.id,
                                                default: true
                                              })
                                            }
                                          />
                                        </div>
                                      </SwiperSlide>
                                    );
                                  })}
                              </Swiper>
                            </div>
                          )}
                        </Col>
                        <Col lg={12} xs={24}>
                          <div style={{ padding: '10px 20px' }} className="slide-product-table">
                            <div className="slide-product-name roboto-medium">
                              {item.attributes.ProductName}
                            </div>
                            <div className="slide-product-details ">
                              <span className="roboto-medium">Description</span>
                              <p className="roboto-regular">{item.attributes.Description}</p>
                            </div>
                            <Divider style={{ margin: '10px 0' }} />
                            {!sizeshow && (
                              <div className="slide-product-dimensions ">
                                <span className="roboto-medium">Dimensions</span>
                                <p className="roboto-regular">
                                  {item.attributes.Length}*{item.attributes.Width}*
                                  {item.attributes.Height}
                                  <span className="product-unit">
                                    {capitalizeFirstLetter(item.attributes.SizeUnit)}
                                  </span>
                                </p>
                              </div>
                            )}
                            <div className="slide-product-Alias ">
                              <div className="roboto-medium">
                                {attributesName?.AliasCode || 'Alias Code'}
                              </div>
                              <div>{item.attributes.ProductId}</div>
                            </div>
                            <div className="slide-product-Alias ">
                              <div className="roboto-medium">
                                {attributesName?.Category || 'Category'}
                              </div>
                              <div>{item.attributes.CategoryName}</div>
                            </div>
                            <div className="slide-product-Alias ">
                              <div className="roboto-medium">
                                {attributesName?.ProductType || 'Product Type'}
                              </div>
                              <div>{item.attributes.ProductTypeName}</div>
                            </div>
                            <div className="slide-product-Alias ">
                              <div className="roboto-medium">
                                {attributesName?.finish || 'Finish'}
                              </div>
                              <div>{item.attributes.FinishName}</div>
                            </div>
                            <div className="slide-product-Alias ">
                              <div className="roboto-medium">
                                {attributesName?.color || 'Color'}
                              </div>
                              <div>{item.attributes.ColorName}</div>
                            </div>
                            <div className="slide-product-Alias ">
                              <div className="roboto-medium">{attributesName?.cbm || 'CBM'}</div>
                              <div>{item.attributes.Total_CBM}</div>
                            </div>
                            {sizeshow && (
                              <div className="slide-product-Alias ">
                                <div className="roboto-medium">
                                  {attributesName?.SizeRange || 'Free Size'}
                                </div>
                                <div>{item.attributes.SizeRange}</div>
                              </div>
                            )}
                            <div className="slide-product-Alias ">
                              <div className="roboto-medium">
                                {attributesName?.GrossWgt || 'Gross Weight'}
                              </div>
                              <div>{item.attributes.GrossWeight}</div>
                            </div>
                            <div className="slide-product-Alias ">
                              <div className="roboto-medium">
                                {attributesName?.NetWgt || 'Net Weight'}
                              </div>
                              <div>{item.attributes.NetWeight}</div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Grid>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </Modal.Body>
        </Modal>
        <Modal open={openGlink} onClose={handleCloseGlink} backdrop="static">
          <Modal.Header>
            <Modal.Title>
              <b>Link</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isCopied ? <Message type="success">Copied!</Message> : null}
            <Stack>
              <Input value={link} readOnly />
              <CopyToClipboard text={link} onCopy={handleCopy}>
                <Button appearance="primary" color="cyan">
                  Copy
                </Button>
              </CopyToClipboard>
            </Stack>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleCloseGlink} appearance="primary" color="cyan">
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERP Daddy Softwere Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};

export default BulkCosting;
